<div class="dialog">
    <div class="dialog-header">
        <h2>{{ (data.title || 'transactions.dialog.status.heading') | translate }}</h2>
    </div>
    <div class="dialog-body">
        <p [innerHTML]="'transactions.dialog.status.text' | translate | newlines"></p>

        <form #form>
            <app-form-textarea name="comment" [required]="true" rows="5" [(ngModel)]="comment" maxlength="255"></app-form-textarea>
        </form>
        <div class="buttons">
            <a class="button button-basic-primary" (click)="onCancel()">{{ 'shared.button.cancel' | translate }}</a>
            <a class="button button-primary" (click)="onConfirm(comment)">{{ 'shared.button.confirm' | translate }}</a>
        </div>
    </div>
</div>

